import { requestAccessToken } from '../../api/auth.api'
import { isSuiteSsoRedirectMode } from '../sso-flags'
import { resolvePayAccessTokenForMicroservices } from './pay-auth-bridge.service'

/**
 * Resolves bearer token for documents API calls.
 * SSO mode → Pay RS256 access token bridged from Identity.
 */
export async function resolveDocumentsAccessToken(payRefreshToken?: string | null): Promise<string> {
  if (isSuiteSsoRedirectMode()) {
    return resolvePayAccessTokenForMicroservices()
  }

  const normalized = payRefreshToken?.replaceAll('"', '').trim() ?? ''

  if (!normalized) {
    throw new Error('Pay refresh token is required for documents API without suite session')
  }

  const {
    data: { accessToken }
  } = await requestAccessToken(normalized)

  return accessToken
}
